import { FC, useMemo, useState } from 'react';
import { UseMultipleChartsType } from '@ecosystem/export-utils';
import {
  MultiStackedChartExportContext,
  MultiStackedChartExportType,
} from './MultiStackedChartExportContext';

interface MultiStackedChartExportProviderProps {
  children: React.ReactNode;
}

const MultiStackedChartExportProvider: FC<MultiStackedChartExportProviderProps> = ({
  children,
}) => {
  const [chartRefsIsInitialisedStatus, setChartRefsIsInitialisedStatus] = useState<boolean[]>([]);
  const [multipleExportCallbacks, setMultipleExportCallbacks] = useState<UseMultipleChartsType>([]);

  const contextValue: MultiStackedChartExportType = useMemo(
    () => ({
      chartRefsIsInitialisedStatus,
      setChartRefsIsInitialisedStatus,
      multipleExportCallbacks,
      setMultipleExportCallbacks,
    }),
    [chartRefsIsInitialisedStatus, multipleExportCallbacks],
  );

  return (
    <MultiStackedChartExportContext.Provider value={contextValue}>
      {children}
    </MultiStackedChartExportContext.Provider>
  );
};

export default MultiStackedChartExportProvider;
